import * as actionTypes from "./actionTypes";



export const loadVendingCount = data => {
  
  return {
    type: actionTypes.LOAD_VENDING_COUNT,
    data
  };
};

export const loadVendingCountSuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_COUNT_SUCCESS,
    data
  };
};

export const loadVendingCountFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_COUNT_FAIL
  };
};

export const loadVendingLocationList = data => {
  
  return {
    type: actionTypes.LOAD_VENDING_LOCATION_LIST,
    data
  };
};

export const loadVendingLocationListSuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_LOCATION_LIST_SUCCESS,
    data
  };
};

export const loadVendingLocationListFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_LOCATION_LIST_FAIL
  };
};

export const loadVendingList = data => {
  
  return {
    type: actionTypes.LOAD_VENDING_LIST,
    data
  };
};

export const loadVendingListSuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_LIST_SUCCESS,
    data
  };
};

export const loadVendingListFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_LIST_FAIL
  };
};


export const loadVendingDetail = (id, data) => {
  
  return {
    type: actionTypes.LOAD_VENDING_DETAIL,
    id,
    data
  };
};

export const loadVendingDetailSuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_DETAIL_SUCCESS,
    data
  };
};

export const loadVendingDetailFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_DETAIL_FAIL
  };
};

export const loadVendingDetailDuplicate = () => {
  return {
    type: actionTypes.LOAD_VENDING_DETAIL_DUPLICATE
  };
};


export const createVending = (data) => {
  return {
    type: actionTypes.CREATE_VENDING,
    data
  };
};

export const createVendingSuccess = () => {
  return {
    type: actionTypes.CREATE_VENDING_SUCCESS
  };
};

export const createVendingFail = () => {
  return {
    type: actionTypes.CREATE_VENDING_FAIL
  };
};



export const updateVending = (id,data) => {
  return {
    type: actionTypes.UPDATE_VENDING,
    id,
    data
  };
};

export const updateVendingSuccess = () => {
  return {
    type: actionTypes.UPDATE_VENDING_SUCCESS
  };
};

export const updateVendingFail = () => {
  return {
    type: actionTypes.UPDATE_VENDING_FAIL
  };
};


export const resetPwd = (id,data) => {
  return {
    type: actionTypes.RESET_PWD_VENDING,
    id,
    data
  };
};

export const resetPwdSuccess = () => {
  return {
    type: actionTypes.RESET_PWD_VENDING_SUCCESS
  };
};

export const resetPwdFail = () => {
  return {
    type: actionTypes.RESET_PWD_VENDING_FAIL
  };
};


export const delVending = (id,data) => {
  
  return {
    type: actionTypes.REMOVE_VENDING,
    id,
    data
  };
};

export const delVendingSuccess = () => {
  
  return {
    type: actionTypes.REMOVE_VENDING_SUCCESS,
  };
};

export const delVendingFail = () => {
  return {
    type: actionTypes.REMOVE_VENDING_FAIL
  };
};



export const rebootVending = (id,data) => {
  return {
    type: actionTypes.REBOOT_VENDING,
    id,
    data
  };
};

export const rebootVendingSuccess = () => {
  return {
    type: actionTypes.REBOOT_VENDING_SUCCESS
  };
};

export const rebootVendingFail = () => {
  return {
    type: actionTypes.REBOOT_VENDING_FAIL
  };
};



export const stopVending = (id,data) => {
  return {
    type: actionTypes.STOP_VENDING,
    id,
    data
  };
};

export const stopVendingSuccess = () => {
  return {
    type: actionTypes.STOP_VENDING_SUCCESS
  };
};

export const stopVendingFail = () => {
  return {
    type: actionTypes.STOP_VENDING_FAIL
  };
};


export const startVending = (id, data) => {
  return {
    type: actionTypes.START_VENDING,
    id,
    data
  };
};

export const startVendingSuccess = () => {
  return {
    type: actionTypes.START_VENDING_SUCCESS
  };
};

export const startVendingFail = () => {
  return {
    type: actionTypes.START_VENDING_FAIL
  };
};



export const testConnection = (id, data) => {
  return {
    type: actionTypes.VENDING_TEST_CONNECTION,
    id,
    data
  };
};

export const testConnectionSuccess = (data) => {
  return {
    type: actionTypes.VENDING_TEST_CONNECTION_SUCCESS,
    data
  };
};

export const testConnectionFail = () => {
  return {
    type: actionTypes.VENDING_TEST_CONNECTION_FAIL
  };
};


export const setPlacement = (id, data) => {
  return {
    type: actionTypes.VENDING_SET_PLACEMENT,
    id,
    data
  };
};

export const setPlacementSuccess = (data) => {
  return {
    type: actionTypes.VENDING_SET_PLACEMENT_SUCCESS,
    data
  };
};

export const setPlacementFail = () => {
  return {
    type: actionTypes.VENDING_SET_PLACEMENT_FAIL
  };
};

export const loadVendingCouncilList = data => {
  return {
    type: actionTypes.LOAD_VENDING_COUNCIL_LIST,
    data
  };
};

export const loadVendingCouncilListSuccess = data => {
  return {
    type: actionTypes.LOAD_VENDING_COUNCIL_LIST_SUCCESS,
    data
  };
};

export const loadVendingCouncilListFail = () => {
  return {
    type: actionTypes.LOAD_VENDING_COUNCIL_LIST_FAIL
  };
};